
import Vue from 'vue';
import { Vue as VueBase, Component, Watch } from 'vue-property-decorator';
import {
  CommercialInvoiceValidationState,
} from '@/features/shipment/helpers/commercialInvoiceValidation';
import GeneralInfo from '@/features/shipment/components/commercialInvoice/GeneralInfo.vue';
import SupportingDocuments from '@/features/shipment/components/commercialInvoice/SupportingDocuments.vue';
import DetailedInfo from '@/features/shipment/components/commercialInvoice/DetailedInfo.vue';
import ShippingTipsNotification from '@/features/shipment/components/commercialInvoice/ShippingTipsNotification.vue';
import { ShippingTips, ShipTo } from '@/features/shipment/types';
import { getShippingTips } from '@/features/shipment/services/shipment.services';
import { scrollToInPage } from '@/features/common/helpers';
import { showFloatingWidgets, hideFloatingWidgets } from '@/features/feedback-tool/helpers';

@Component({
  components: {
    GeneralInfo,
    SupportingDocuments,
    DetailedInfo,
    ShippingTipsNotification,
  },
  provide(): { commercialInvoiceValidationState: CommercialInvoiceValidationState } {
    return {
      commercialInvoiceValidationState: (this as any).commercialInvoiceValidationState,
    };
  },
})
export default class CommercialInvoice extends VueBase {
  private commercialInvoiceValidationState = Vue.observable<CommercialInvoiceValidationState>({
    attempted: false,
  });

  private shippingTips: ShippingTips | null = null;

  get toAddress(): ShipTo {
    return this.$store.getters.getShipToInProgress;
  }

  get isPaperlessTradeSupported(): boolean {
    return this.$store.getters.isPaperlessTradeSupported;
  }

  get isHelpfulNotificationEnabled(): boolean {
    const notificationPrefs = this.$store.getters.getNotificationPrefs;
    if (!notificationPrefs) return true;

    const notification = notificationPrefs.find((pref) => pref.name === 'CICountryRequirements');
    if (!notification) return true;
    return notification.show;
  }

  // eslint-disable-next-line class-methods-use-this
  get shipmentSection(): HTMLElement {
    return document.querySelector('.shipment') as HTMLElement;
  }

  private hideFloatingWidgets = hideFloatingWidgets;

  private showFloatingWidgets = showFloatingWidgets;

  @Watch('toAddress', { immediate: true })
  private getShippingTips(newValue: ShipTo) {
    if (newValue.countryCode && this.isHelpfulNotificationEnabled) {
      this.fetchShippingTips();
    }
  }

  destroyed(): void {
    window.removeEventListener('resize', this.handleResize);
    this.showFloatingWidgets();
    this.commercialInvoiceValidationState.attempted = false;
  }

  private handleResize() {
    if (window.innerWidth < 720 && this.shippingTips && this.isHelpfulNotificationEnabled) {
      this.hideFloatingWidgets();
      return;
    }
    this.showFloatingWidgets();
  }

  // eslint-disable-next-line class-methods-use-this
  mounted(): void {
    scrollToInPage();
    window.addEventListener('resize', this.handleResize);
    setTimeout(() => {
      this.handleResize();
    }, 3000);
  }

  private async fetchShippingTips() {
    this.shippingTips = await getShippingTips(
      this.toAddress.countryCode,
    );
  }
}
